import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card shadow-sm mb-4" }
const _hoisted_2 = { class: "card-content" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "fw-bold text-secondary" }
const _hoisted_8 = { class: "overflow-hidden" }
const _hoisted_9 = { class: "col-md-2 d-flex flex-column justify-content-center" }
const _hoisted_10 = { class: "text-center" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = {
  key: 1,
  class: "text-center pt-3"
}
const _hoisted_14 = {
  key: 1,
  class: "loading-card-area"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_modal = _resolveComponent("modal")!
  const _component_pagination = _resolveComponent("pagination")!
  const _component_loading = _resolveComponent("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[7] || (_cache[7] = _createElementVNode("div", { class: "card-header text-white bg-secondary fw-bold" }, "Scenarios in Draft", -1)),
    _createElementVNode("div", _hoisted_2, [
      (!_ctx.visit_loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (Object.keys(_ctx.props.scenario_drafts).length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.props.scenario_drafts, (drafts) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: drafts.id,
                      class: "row scenario-card"
                    }, [
                      _createElementVNode("div", {
                        class: "col-md-10",
                        onClick: ($event: any) => (_ctx.router.push({name:'scenario.show',params:{id:drafts.id}}))
                      }, [
                        _createElementVNode("img", {
                          src: drafts.patient_image.location,
                          class: "rounded-circle float-start",
                          width: "75"
                        }, null, 8, _hoisted_6),
                        _createElementVNode("div", _hoisted_7, _toDisplayString(drafts.patient_name), 1),
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("span", null, _toDisplayString(drafts.title), 1)
                        ])
                      ], 8, _hoisted_5),
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("h3", _hoisted_10, [
                          _createElementVNode("i", {
                            class: "fas fa-drafting-compass text-primary me-4",
                            onClick: ($event: any) => (_ctx.router.push({name:'scenario.show',params:{id:drafts.id}})),
                            title: "Make Edits"
                          }, null, 8, _hoisted_11),
                          _createElementVNode("i", {
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showDeleteModal())),
                            class: "fas fa-trash text-primary",
                            title: "Delete"
                          })
                        ])
                      ]),
                      _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1)),
                      _cache[6] || (_cache[6] = _createElementVNode("div", { class: "col-12 thin-line" }, null, -1)),
                      _createVNode(_component_modal, {
                        modelValue: _ctx.deleteModal,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.deleteModal) = $event))
                      }, {
                        header: _withCtx(() => _cache[3] || (_cache[3] = [
                          _createTextVNode("Permanently Delete Scenario")
                        ])),
                        default: _withCtx(() => [
                          _cache[4] || (_cache[4] = _createElementVNode("p", null, "Are you sure you want to delete this scenario?", -1)),
                          _createElementVNode("button", {
                            class: "btn btn-xs btn-secondary-alt float-end",
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showDeleteModal()))
                          }, "Cancel"),
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-primary btn-xs",
                            onClick: ($event: any) => (_ctx.deleteScenario(drafts.id))
                          }, "Permanently Delete", 8, _hoisted_12)
                        ]),
                        _: 2
                      }, 1032, ["modelValue"])
                    ]))
                  }), 128)),
                  (Object.keys(_ctx.props.scenario_drafts).length > 10)
                    ? (_openBlock(), _createBlock(_component_pagination, {
                        key: 0,
                        items: _ctx.props.scenario_drafts,
                        page_start: _ctx.page_start,
                        page_end: _ctx.page_end,
                        onNextPage: _ctx.nextPage,
                        onPreviousPage: _ctx.previousPage,
                        label: 'Scenarios'
                      }, null, 8, ["items", "page_start", "page_end", "onNextPage", "onPreviousPage"]))
                    : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createElementBlock("p", _hoisted_13, "No Scenarios in Draft"))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _createVNode(_component_loading, {
              active: _ctx.visit_loading,
              "is-full-page": false
            }, null, 8, ["active"])
          ]))
    ])
  ]))
}